import { Button, Input, Modal } from "antd";
import React, { useState } from "react";
import MyMap from "./map";
import "./style.css";

const LocationModal = ({ open, setOpen, location, setLocation }) => {
  const [locationValue, setLocationValue] = useState(location);
  const [localName, setLocalName] = useState("");
  const handleLocationConfirm = () => {
    setLocation(locationValue);
    setOpen(false);
  };

  return (
    <Modal
      className="modal-location"
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
    >
      <MyMap locationValue={location} setLocationValue={setLocationValue} />
      <Button className="button2" onClick={() => handleLocationConfirm()}>
        Select
      </Button>
    </Modal>
  );
};

export default LocationModal;
